// src/service/dashboard.service.js
import axios from 'axios';
import config from "../environment/config";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:8082';

const DASHBOARD_API = `${API_BASE_URL}/api/admin/dashboard`;

/**
 * Fetch dashboard statistics
 * API: GET /api/admin/dashboard/stats
 */
export const getDashboardStats = async () => {
  try {
    const response = await axios.get(`${DASHBOARD_API}/stats`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard stats:', error);
    throw error;
  }
};

/**
 * Fetch recent activity data
 * API: GET /api/admin/dashboard/recent-activity
 */
export const getRecentActivity = async () => {
  try {
    const response = await axios.get(`${DASHBOARD_API}/recent-activity`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching recent activity:', error);
    throw error;
  }
};
